import { render, staticRenderFns } from "./feefo-stars.vue?vue&type=template&id=88c427c2&scoped=true&lang=pug&"
import script from "./feefo-stars.vue?vue&type=script&lang=js&"
export * from "./feefo-stars.vue?vue&type=script&lang=js&"
import style0 from "./feefo-stars.vue?vue&type=style&index=0&id=88c427c2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88c427c2",
  null
  
)

export default component.exports